<template>
    <div class="row dashboard">
        <FullPageLoader :isLoading="loading"/>

        <div class="column">
            <h1 class="title">
                {{ greeting }}{{ user.name ? ', ' + user.name : '' }}.
            </h1>

            <h3>Dashboard</h3>

            <div class="row">
                <div class="column large-7">
                    <div class="card">
                        <h4>Facturen en betalingen</h4>

                        <b-tabs position="is-right" class="block" v-model="paymentTab" @input="paymentTabChanged">
                            <b-tab-item label="Dagelijks">
                                <apexchart type="area" :key="paymentsKey" width="100%" :options="payments.chartOptions" :series="payments.series"></apexchart>
                            </b-tab-item>
                            <b-tab-item label="Opbouwend">
                                <apexchart type="area" :key="paymentsKey" width="100%" :options="payments.chartOptions" :series="payments.series"></apexchart>
                            </b-tab-item>
                            <!-- <b-tab-item label="Videos"></b-tab-item> -->
                        </b-tabs>
                    </div>
                </div>
                <div class="column large-5">
                    <div class="card">
                        <h4>Betaalstatus facturen</h4>

                        <div v-if="noInvoices" class="selectorganisation" style="padding:65px 15px;">
                            <h3>Geen facturen gevonden.</h3>
                        </div>
                        <div v-else>
                            <apexchart :key="invoicesKey" type="donut" height="188" width="100%" :options="openInvoices.chartOptions" :series="openInvoices.series"></apexchart>
                        </div>
                    </div>

                    <br>

                    <div class="card">
                        <h4>Actieve contracten{{ !_.isNull(dateRange) ? ' in periode gestart' : '' }}</h4>
                        <h2><strong>{{ hideSensitiveData ? '*********' : formatNumber(activeContracts) }}</strong></h2>

                        <span v-show="dateRange">
                            <div class="row">
                                <div class="column medium-6">
                                    <h4>Inkomsten</h4>
                                    <h2 class="margin0"><strong>&euro;&nbsp;{{ hideSensitiveData || loading ? '********' : income }}</strong></h2>
                                </div>
                                <div class="column medium-6">
                                    <h4>Gecrediteerd</h4>
                                    <h2 class="text-danger margin0"><strong class="text-danger">-&nbsp;&euro;&nbsp;{{ hideSensitiveData || loading ? '********' : credited }}</strong></h2>
                                </div>
                            </div>
                        </span>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="column large-4 medium-6">
                    <div class="card">
                        <h6>Verzonden e-mails{{ !_.isNull(dateRange) ? ' in periode' : '' }}</h6>
                        <h2 class="margin0"><strong>{{ hideSensitiveData ? '********' : formatNumber(emailsSend) }}</strong></h2>
                    </div>
                </div>
                <div class="column large-4 medium-6 end">
                    <div class="card">
                        <h6>{{ !_.isNull(dateRange) ? 'Nieuwe klanten in periode' : 'Totaal aantal klanten' }}</h6>
                        <h2 class="margin0"><strong>{{ hideSensitiveData ? '********' : formatNumber(customerCount) }}</strong></h2>
                    </div>
                </div>
                <div class="column large-4 medium-6">
                    <div class="card">
                        <h6>Online verhuur aanvragen</h6>
                        <h2 class="margin0"><strong>{{ hideSensitiveData ? '********' : formatNumber(onlineRentals) }}</strong></h2>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="column">
                    <hr>
                    <h2>Actuele statussen</h2>
                    <b-notification v-show="!_.isNull(dateRange)" type="is-warning is-light">
                        Dit zijn actuele statussen, het datumbereik wordt niet meegenomen in de onderstaande grafieken.
                    </b-notification>
                </div>
            </div>

            <div class="row">
                <div class="column large-7">
                    <div class="card">
                        <h4>Producten</h4>

                        <div class="selectorganisation" v-if="dataBelongsTo == 'all'">
                            <h3>Selecteer eerst een organisatie.</h3>
                        </div>
                        <div class="selectorganisation" v-else-if="noProducts">
                            <h3>{{ user.role == 'pit' ? 'Geen producten gevonden voor deze organisatie.' : 'Geen producten gevonden.' }}</h3>
                        </div>
                        <div v-else>
                            <apexchart :key="updateProductGraphKey" type="bar" width="100%" :options="productStatus.chartOptions" :series="productStatus.series"></apexchart>
                        </div>
                    </div>
                </div>
                <div class="column large-5" style="min-height:300px">
                    <div class="card">
                        <h4>Boxen</h4>

                        <div class="selectorganisation" v-if="dataBelongsTo == 'all'">
                            <h3>Selecteer eerst een organisatie.</h3>
                        </div>
                        <div class="selectorganisation" v-else-if="noBoxes">
                            <h3>{{ user.role == 'pit' ? 'Geen producten gevonden voor deze organisatie.' : 'Geen producten gevonden.' }}</h3>
                        </div>
                        <div v-else>
                            <apexchart :key="updateBoxKey" type="pie" width="100%" :options="boxchart.chartOptions" :series="boxchart.series"></apexchart>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="column" v-if="(env == 'local' || env == 'test') && (user && user.role == 'pit')">
            <hr>
            <TestModule />
        </div>
    </div>
</template>

<script>
import TestModule from './TestModule'
import paramsMixin from '@/mixins/paramsMixin'

// CHARTS: https://apexcharts.com/vue-chart-demos/

export default {
    name: 'Dashboard',

    components: {
        TestModule
    },

    mixins: [paramsMixin],

    data() {
        return {
            paymentsKey: 0,
            updateProductGraphKey: 0,
            updateBoxKey: 0,
            invoicesKey: 0,
            loading: false,

            noInvoices: false,
            noBoxes: false,
            noProducts: false,

            searchParams: typeof(this.$store.state.searchQueries['Dashboard']) != 'undefined' ? this.$store.state.searchQueries['Dashboard'] : null,

            activeContracts: 0,
            income: '0.00',
            credited: '0.00',
            emailsSend: 0,
            customerCount: 0,
            onlineRentals: 0,

            paymentTab: 1,
            paymentType: 'increasing',
            payments: {
                series: [{
                    name: 'Gefactureerd',
                    data: []
                }, {
                    name: 'Betaald',
                    data: []
                }, {
                    name: 'Mislukt',
                    data: []
                },
                {
                    name: 'Gecrediteerd',
                    data: []
                }],
                chartOptions: {
                    chart: {
                        height: 350,
                        type: 'area',
                        zoom: {
                            autoScaleYaxis: true
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    colors: ['#5963d7', '#1ea94f', '#ffdd57', '#cc091e'],
                    yaxis: {
                        show: this.hidePrices,
                    },
                    xaxis: {
                        type: 'date',
                        tickAmount: 10,
                        categories: [],
                        labels: {
                            rotate: -30,
                            rotateAlways: true,
                            formatter: function(val, timestamp) {
                                return moment(val, 'YYYY-MM-DD').format('DD MMM')
                            }
                        }
                    },
                    tooltip: {
                        x: {
                            format: 'dd/MM/yy'
                        },
                    },
                }
            },

            boxchart: {
                series: [0, 0, 0],
                chartOptions: {
                    chart: {
                        type: 'pie',
                    },
                    labels: ['Vrij', 'Gereserveerd', 'Verhuurd', 'Aflopend', 'Inactief', 'Verhuurd + Gereserveerd', 'Geëscaleerd'],
                    colors: ['#1ea94f', '#5963d7', '#cc091e', '#f8ac00', '#0a0a0a', '#A020F0', '#FF00FF'],
                    responsive: [{
                        breakpoint: 678,
                        options: {
                                chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                },
            },

            openInvoices: {
                series: [0, 0],
                chartOptions: {
                    chart: {
                        type: 'donut',
                    },
                    labels: ['Betaald', 'Open'],
                    colors: ['#1ea94f', '#FF6200'],
                    plotOptions: {
                        pie: {
                            startAngle: -90,
                            endAngle: 90,
                        }
                    },
                    grid: {
                        padding: {
                            bottom: -129
                        }
                    },
                    responsive: [{
                        breakpoint: 678,
                        options: {
                                chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                }
            },

            productStatus: {
                series: [{
                    name: 'Voorraad',
                    data: []
                }, {
                    name: 'Verhuurd',
                    data: []
                }, {
                    name: 'Verkocht',
                    data: []
                },
                // {
                //     name: 'Bucket Slope',
                //     data: [9, 7, 5, 8, 6, 9, 4]
                // }, {
                //     name: 'Reborn Kid',
                //     data: [25, 12, 19, 32, 25, 24, 10]
                // }
                ],
                chartOptions: {
                    chart: {
                        type: 'bar',
                        height: 350,
                        stacked: true
                    },
                    colors: ['#1ea94f', '#FF6200', '#118fe4'],
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        },
                    },
                    xaxis: {
                        categories: [],
                    },
                    // tooltip: {
                    // y: {
                    //     formatter: function (val) {
                    //         return val + "K"
                    //     }
                    // }
                    // },
                    legend: {
                        position: 'right',
                        // horizontalAlign: 'left',
                        // offsetX: 40
                        offsetY: 40
                    }
                },
            }
        }
    },

    computed: {
        env() {
            return this.$store.state.env
        },

        user() {
            return this.$store.state.user
        },

        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        },

        greeting() {
            return moment().format('HH') < 12 ? 'Goedemorgen' : moment().format('HH') < 18 ? 'Goedemiddag' : 'Goedenavond'
        }
    },

    created(){
        this.loading = true

        this.getSearchParams().then(() => {
            this.loadAsyncData()
        })
    },

    mounted() {
        this.checkRedirect()
    },

    methods: {
        loadAsyncData(){
            // Set filter params & admin params
            const params = this.setParams(this.searchParams, 'Dashboard')

            this.loading = true

            axios.get(`/api/dashboard${params ? '?' + params : ''}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                // Top
                this.setPayments(response.data.payments)
                this.activeContracts = response.data.contracts
                this.income = this.number_format(response.data.income)
                this.credited = this.number_format(response.data.credited)
                this.emailsSend = response.data.sendEmails
                this.customerCount = response.data.customers > 0 ? response.data.customers : 0
                this.onlineRentals = response.data.onlineRentals

                // Actual
                this.setBoxes(response.data.boxes)
                this.setOpenInvoices(response.data.openinvoices)
                this.setProducts(response.data.products)

                this.$store.dispatch('setSearchQuery', {type: 'Dashboard', query: params})
            }).catch((error) => {
                console.error('[❌] Error while fetching the dashboard:', error)
            }).then(() => {
                this.loading = false
                this.searchParams = null
            })
        },

        setPayments(data){
            // Reset
            this.payments.chartOptions.xaxis.categories = []
            this.payments.series[0].data = []
            this.payments.series[1].data = []
            this.payments.series[2].data = []
            this.payments.series[3].data = []

            // setTimeout(() => {
                if (this.paymentType === 'day') {
                    _.each(data, (payments, date) => {
                        // console.log(moment(date, 'DD-MM-YYYY')._d)
                        this.payments.chartOptions.xaxis.categories.push(moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD'))

                        this.payments.series[0].data.push(this.toFixedNmbr(payments.invoiced))
                        this.payments.series[1].data.push(this.toFixedNmbr(payments.paid))
                        this.payments.series[2].data.push(this.toFixedNmbr(payments.failed))
                        this.payments.series[3].data.push(this.toFixedNmbr(payments.credited))
                    })
                } else if (this.paymentType == 'increasing') {
                    let totalInvoiced = 0
                    let totalPaid = 0
                    let totalFailed = 0
                    let totalCredited = 0

                    _.each(data, (payments, date) => {
                        this.payments.chartOptions.xaxis.categories.push(moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD'))

                        totalInvoiced += payments.invoiced
                        totalPaid += payments.paid
                        totalFailed += payments.failed
                        totalCredited += payments.credited

                        this.payments.series[0].data.push(this.toFixedNmbr(totalInvoiced))
                        this.payments.series[1].data.push(this.toFixedNmbr(totalPaid))
                        this.payments.series[2].data.push(this.toFixedNmbr(totalFailed))
                        this.payments.series[3].data.push(this.toFixedNmbr(totalCredited))
                    })
                }

                this.$set(this, 'paymentsKey', this.paymentsKey + 1)
            // }, 500)
        },

        setBoxes(data){
            if(data.length == 0 || Object.keys(data).length == 0){
                this.noBoxes = true
                return
            }
            this.noBoxes = false

            let boxesData = []

            boxesData[0] = _.has(data, 'free') ? data.free : 0
            boxesData[1] = _.has(data, 'reserved') ? data.reserved : 0
            boxesData[2] = _.has(data, 'taken') ? data.taken : 0

            boxesData[3] = _.has(data, 'ending') ? data.ending : 0
            boxesData[4] = _.has(data, 'inactive') ? data.inactive : 0
            boxesData[5] = _.has(data, 'taken+reserved') ? data['taken+reserved'] : 0

            boxesData[6] = (data.escalated || 0) + (data.escalated_deurwaarder || 0)

            this.boxchart.series = boxesData

            ++this.updateBoxKey
        },

        setOpenInvoices(data){
            if(data.paid == 0 && data.unpaid == 0){
                this.noInvoices = true
                return
            }
            this.noInvoices = false

            this.openInvoices.series = [data.paid, data.unpaid]

            ++this.invoicesKey
        },

        setProducts(data){
            if(data.length == 0 || Object.keys(data).length == 0){
                this.noProducts = true
                return
            }
            this.noProducts = false

            let products = []
            let productsSold = this.productStatus.series

            // reset
            this.productStatus.chartOptions.xaxis.categories = []
            this.productStatus.series[0].data = []
            this.productStatus.series[1].data = []
            this.productStatus.series[2].data = []

            _.each(data, (product) => {
                products.push(product.name)

                productsSold[0].data.push(product.available)
                productsSold[1].data.push(product.rented_out)
                productsSold[2].data.push(product.sold)
            })

            // Set products
            this.productStatus.chartOptions.xaxis.categories = products

            ++this.updateProductGraphKey
        },

        toFixedNmbr(val, decimals = 2){
            val = parseFloat(val)
            return val.toFixed(decimals)
        },

        number_format(val, decimals = 2) {
            val = parseFloat(val)
            return val.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
        },

        checkRedirect(){
            if(this.user && _.has(this.user, 'settings.loginredirect') && !this.$store.state.auth_redirected) {
                switch(this.user.settings.loginredirect){
                    case 1:
                        if(this.user.deurwaarder) {
                            this.$router.push({name: 'InvoicesOverview', params: {type: 'geescaleerd'}})
                            return;
                        }

                        // Redirect to invoices if you cannot.
                        if(_.has(this.user.organisation_settings, 'dashboard_onlyadmin') && this.user.organisation_settings.dashboard_onlyadmin == 1 && (this.user.role != 'pit' && !this.user.is_admin)){
                            this.$router.push({name: 'InvoicesOverview', params: {type: 'recent'}})
                        } else {
                            this.getSearchParams().then(() => {
                                this.loadAsyncData()
                            })
                        }
                    break;
                    case 2:
                        // Boxen lijstweergave
                        this.$router.push({name: 'BoxesOverview'})
                    break;
                    case 3:
                        // Boxen plattegrond
                        this.$router.push({name: 'BoxesOverview', query: {floormap: '1'}})
                    break;
                    case 4:
                        // Contracten
                        this.$router.push({name: 'ContractsOverview'})
                    break;
                    case 5:
                        // Facturen
                        this.$router.push({name: 'InvoicesOverview'})
                    break;
                    case 6:
                        // Klanten
                        this.$router.push({name: 'CustomersOverview'})
                    break;
                }

                this.$store.dispatch('setAuthRedirected', true)
                return;
            } else if(_.has(this.user.organisation_settings, 'dashboard_onlyadmin') && this.user.organisation_settings.dashboard_onlyadmin == 1 && (this.user.role != 'pit' && !this.user.is_admin)){
                if(this.user.deurwaarder) {
                    this.$router.push({name: 'InvoicesOverview', params: {type: 'geescaleerd'}})
                    return;
                }

                this.$router.push({name: 'InvoicesOverview', params: {type: 'recent'}})
            } else {
                if(this.user.deurwaarder) {
                    this.$router.push({name: 'InvoicesOverview', params: {type: 'geescaleerd'}})
                    return;
                }

                this.$router.push({name: 'Dashboard'})
            }
        },

        formatNumber(number){
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },

        paymentTabChanged (tab) {
            this.paymentType = tab === 0 ? 'day' : 'increasing'
            // this.setPayments(this.paymentsData)
            this.loadAsyncData()
        }
    },

    watch: {
        hideSensitiveData(newVal){
            this.payments.chartOptions.yaxis.show = !newVal
            ++this.paymentsKey
        },

        user(){
            this.checkRedirect()
        },

        '$route.query.org'(newOrg, oldOrg) {
            if (!newOrg) return

            if (newOrg !== oldOrg) {
                this.$store.dispatch('setAuthRedirected', false)
                this.checkRedirect()
            }
        }
    }
}
</script>